import React, { useEffect } from 'react';
import { createContext, useState } from "react";
import { basePath } from '../Constants/constant';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const AppContext = createContext(null);

function ContextApi({ children }) {
    const [industry, setIndustry] = useState("");
    const [adminNavbar, setAdminNavbar] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const [token, setToken] = useState(localStorage.getItem("token"));
    const [userId, setUserId] = useState(localStorage.getItem("userId"));
    const [user, setUser] = useState([]);
    const [userManual, setUserMaual] = useState('');
    const [notifications, setNotifications] = useState([]);
    const [apiHeaderJSON, setHeaderJSON] = useState({ token: localStorage.getItem("token"),  "Accept": "application/json",  "Content-Type": "application/json",  "x-user-id": localStorage.getItem("userId"), });
    const [apiHeaderFile, setHeaderFile] = useState({ token: localStorage.getItem("token"),  "Accept": "application/json",   "Content-Type": "multipart/form-data",  "x-user-id": localStorage.getItem("userId"), });

    const getData=()=>{
        let options = {
            url: `${basePath}/verify`,
            method: "GET",
            headers: {
                Accept: "application/json",
                token: localStorage.getItem("token")
            },
        }
        axios(options)
            .then((responce) => {
                // console.log(responce);
                if (responce.status === 200) {
                    setUser(responce?.data.permissions);
                    setUserMaual(responce?.data.manual_url)
                    // console.log("Information entered successfully");
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    useEffect(() => {
        setToken(localStorage.getItem("token"));
            if(localStorage.getItem("token")){
                getData();
            }
    }, [token]);
    // console.log(user);

    const getNotifications = async () => {
        try {
             let options = {
                headers:apiHeaderJSON
            }
            const response = await axios.get(`${basePath}/GetPositionNotifications`, options);
            setNotifications(response.data.data);
        } catch (error) {
            console.log("There is some server issue!!")
        }
    };

    useEffect(() => {
        localStorage.removeItem("lastNotificationFetch");
        if(!["Recruiter", "Team Lead"].includes(localStorage.getItem("role"))){
            const checkDateAndFetch = () => {
                const today = new Date().toISOString().split("T")[0];
                const lastFetch = localStorage.getItem("lastNotificationFetch");

                if (today !== lastFetch) {
                getNotifications();
                localStorage.setItem("lastNotificationFetch", today);
                }
            };

            // Run once on mount
            checkDateAndFetch();

            // Run when tab becomes visible again
            document.addEventListener("visibilitychange", () => {
                if (!document.hidden) {
                checkDateAndFetch();
                }
            });

            return () => {
                document.removeEventListener("visibilitychange", checkDateAndFetch);
            };
        }
    }, []);

    return (
        <AppContext.Provider value={{
            industry, setIndustry,
            adminNavbar, setAdminNavbar,
            isModalOpen, setIsModalOpen,
            token, setToken,
            user, setUser,
            getData,apiHeaderJSON,apiHeaderFile,
            isOpen, setIsOpen,
            notifications, getNotifications,
            userManual, setUserMaual
        }}>
            {children}
        </AppContext.Provider>
    );
}

export default ContextApi;